import Connection from "../config/connection";
import axios from "axios";

class AxiosRestClient {
  static postRequestWithoutToken(url, payload) {
    return axios.post(Connection.getResturl() + url, payload);
  }
  static getRequestWithoutToken(url, payload) {
    // return axios.get(Connection.getResturl() + url, payload);
    return axios.get(url, payload);
  }
  // static postRequest(url, payload) {
  //     const token = localStorage.getItem('token');
  //     return axios.post(Connection.getResturl() + url, payload, {
  //         headers: {
  //             "Authorization": "Bearer " + token
  //         }
  //     });
  // }
  // static getRequest(url, params) {
  //     const token = localStorage.getItem('token');
  //     let query = querystring.stringify(params);
  //     return axios.get(Connection.getResturl() + url + "?" + query, {
  //         headers: {
  //             "Authorization": "Bearer " + token
  //         }
  //     });
  // }
  //
  // static postRequest(url, payload) {
  //     const token = localStorage.getItem('token');
  //
  //     return axios.post(Connection.getResturl() + url, payload, {
  //         headers: {
  //             "Authorization": "Bearer " + token
  //         }
  //     });
  // }
  //
  // static postImageRequest(url, payload) {
  //     const token = localStorage.getItem('token');
  //     return axios.post(Connection.getResturl() + url, payload, {
  //         headers: {
  //             "Authorization": "Bearer " + token,
  //             'content-type': 'application/x-www-form-urlencoded'
  //         }
  //     });
  // }
  // static putRequest(url, payload) {
  //     const token = localStorage.getItem('token');
  //
  //     return axios.put(Connection.getResturl() + url, payload, {
  //         headers: {
  //             "Authorization": "Bearer " + token
  //         }
  //     });
  // }
  // static deleteRequest(url, payload) {
  //     const token = localStorage.getItem('token');
  //
  //     return axios.delete(Connection.getResturl() + url, {
  //         headers: {
  //             "Authorization": "Bearer " + token
  //         }
  //     });
  // }
}

export default AxiosRestClient;
